class CustomSelect extends HTMLElement {
  static openSelects = new Set();
  static outsideClickHandler = (event) => {
    CustomSelect.openSelects.forEach((select) => {
      select.clickOutside(event);
    });
  };

  static registerOpen(select) {
    CustomSelect.openSelects.add(select);
    if (CustomSelect.openSelects.size === 1) {
      document.addEventListener('click', CustomSelect.outsideClickHandler);
    }
  }

  static unregisterOpen(select) {
    CustomSelect.openSelects.delete(select);
    if (CustomSelect.openSelects.size === 0) {
      document.removeEventListener('click', CustomSelect.outsideClickHandler);
    }
  }

  constructor() {
    super();
    this.isOpen = false;
    this.position = this.getAttribute('data-position');
    this.select = this.querySelector('select');
    this.stickyButton = this.dataset.stickyBtn ? document.querySelector('#' + this.dataset.stickyBtn) : null;
    this.containerClass = this.getAttribute('data-container-class') || '';
    this.selectContainerPosition = this.getAttribute('data-position') || 'absolute';
    this.selectTrigger = this.querySelector('.select-trigger')
    this.mobileDrawer = this.dataset.mobileDrawer
    this.isMobile = new DeviceWidth().isMobile;

    if (this.isMobile) {
      this.setMobilePrefix();
    }
  }

  getSelectedOption() {
    return this.select.querySelector('option[value="' + this.select.value + '"]');
  }
  setMobilePrefix() {
    this.setAttribute('data-mobile', true)
    const prefix = this.select.getAttribute('data-prefix') || '';
    const selectedOption = this.getSelectedOption();
    if (selectedOption) {
      selectedOption.text = prefix + ' ' + selectedOption.text;
    }

    this.select.addEventListener('change', () => {
      // Get the selected value and prefix
      const selectedOption = this.getSelectedOption();
      if (selectedOption) {
        selectedOption.text = prefix + ' ' + selectedOption.text;
      }

      this.updateMobileTrigger(selectedOption.text)

      // Reset the text of other options
      const options = this.select.options;
      for (let i = 0; i < options.length; i++) {
        if (options[i] !== selectedOption) {
          options[i].text = options[i].text.replace(prefix + ' ', ''); // Remove prefix from other options
        }
      }
    });

  }

  createWrapperElement() {
    this.wrapper = document.createElement('div');
    const selectWrapperClass = 'select-wrapper ' + this.select.className;
    this.wrapper.setAttribute('class', selectWrapperClass);

    if (this.select.disabled) {
      this.wrapper.setAttribute('disabled', true);
    }

    this.hiddenInput = document.createElement('input');
    this.hiddenInput.setAttribute('type', 'hidden');
    this.hiddenInput.setAttribute('id', this.select.getAttribute('id') + '-selectedIndex');
    this.hiddenInput.setAttribute('class', 'variant-gtm');
    this.displayValue = document.createElement('div');
    this.displayValue.setAttribute('class', 'display-value');
    this.wrapper.addEventListener('click', () => {
      this.toggleSelf(this.selectListContainer);
    });
    
    this.valueText = document.createElement('span');
    this.valueText.setAttribute('class', 'value-text');
    this.valueText.innerHTML = '';

    this.wrapper.appendChild(this.hiddenInput);
    this.displayValue.appendChild(this.valueText);
    this.wrapper.appendChild(this.displayValue);

    this.appendChild(this.wrapper);

    this.addEventListener('reloadCustomSelect', (event) => {
      this.wrapper.dispatchEvent(new Event('click', { 
        bubbles: true,
        cancelable: false,
        composed: true
      }));
    })
    
  }

  createSelectListContainer() {
    this.selectListContainer = document.createElement('div');
    this.selectContainer = document.createElement('ul');
    this.selectContainer.setAttribute('class', 'tw-scrollable');
    this.selectListContainer.setAttribute('class', `select-container ${this.containerClass}`);
    // this.selectContainer.style.visibility = 'hidden';
    this.selectListContainer.setAttribute('id', this.select.getAttribute('id') + '-container');
    this.selectListContainer.addEventListener('onblur', function() {
      this.toggleSelf(this.selectContainer);
    });

    this.selectListContainer.appendChild(this.selectContainer);

    if(document.getElementById(this.select.getAttribute('id') + '-container')) {
      document.getElementById(this.select.getAttribute('id') + '-container').remove();
    }

    if(this.isMobile) {
      if(this.mobileDrawer && document.getElementById(this.mobileDrawer)) {
        document.getElementById(this.mobileDrawer).querySelector('.sidebar__content').appendChild(this.selectListContainer)
      }
    } else {
      this.position == 'absolute' ? document.body.appendChild(this.selectListContainer) : this.wrapper.appendChild(this.selectListContainer)
    }

    this.createOptions();

  }

  connectedCallback() {
    this.init();

    this.addEventListener('closeCustomSelect', () => {
      if (this.isOpen) this.toggleSelf();
    })
  }

  disconnectedCallback() {
    CustomSelect.unregisterOpen(this);
  }

  init() {
    this.createWrapperElement();
    this.getDefaultOption();
  }

  applyStyle() {
    if (this.selectContainerPosition !== 'absolute') return;
    this.selectContainer.style.width = `${this.offsetWidth}px`;
    const { top, left } = this.getBoundingClientRect();
    this.selectContainer.style.top = `${top + window.scrollY}px`;
    this.selectContainer.style.left = `${left + window.scrollX}px`;
  }

  toggleSelf() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.createSelectListContainer();
      requestAnimationFrame(() => {
        if (this.isOpen) this.applyStyle();
      });
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.querySelector('.select-wrapper').classList.add('open');
    CustomSelect.registerOpen(this);
    const selectListContainer = this.selectListContainer;
    // this.selectContainer.style.visibility = 'visible';
    setTimeout(function(){
      selectListContainer.classList.add('visible');
    }, 100);
    setTimeout(function(){
      selectListContainer.classList.add('opened');
    }, 300);
    
    this.selectListContainer.focus();

    if(this.isMobile && this.mobileDrawer && document.getElementById(this.mobileDrawer).querySelector('.sidebar:not(.sidebar-opened)')) {
      publish(PUB_SUB_EVENTS.drawerOpen, { source: this.mobileDrawer });
    }
  }

  close() {
    CustomSelect.unregisterOpen(this);
    const selectListContainer = this.selectListContainer;
    if (!selectListContainer) return;
    this.querySelector('.select-wrapper').classList.remove('open');
    selectListContainer.classList.remove('visible', 'opened');
    selectListContainer.blur();
    // this.selectContainer.style.visibility = 'hidden';
    setTimeout(function(){
      selectListContainer.remove();
      if (this.selectListContainer === selectListContainer && !this.isOpen) {
        this.selectListContainer = null;
        this.selectContainer = null;
      }
    }.bind(this), 300);
    
    if(this.isMobile && this.mobileDrawer && document.getElementById(this.mobileDrawer).querySelector('.sidebar.sidebar-opened')) {
      publish(PUB_SUB_EVENTS.drawerClose, { source: this.mobileDrawer });
    }
  }

  selected(opt) {
    this.updateValues(opt);
    let event = new Event('change', { bubbles: true });
    this.select.dispatchEvent(event);
    this.toggleSelf(this.selectListContainer);
    this.createOptions();
    this.updateStickyButton(opt);
  }

  updateStickyButton(opt) {
    if (!this.stickyButton) return;

    const submitBtn = this.stickyButton.querySelector('.submit-btn');
    const triggerBtn = this.stickyButton.querySelector('.trigger-btn');
    const optionSelected = this.stickyButton.querySelector('.option-selected');

    if (opt.value != '-') {
      optionSelected.innerHTML = opt.value;
      triggerBtn?.classList.add('tw-hidden');
      submitBtn?.classList.remove('tw-hidden');

      if (!this._stickySubmitHandler) {
        this._stickySubmitHandler = () => {
          document.querySelector('.product-form form')?.dispatchEvent(new Event('submit'));
        };
        submitBtn?.addEventListener('click', this._stickySubmitHandler);
      }
    } else {
      optionSelected.innerHTML = '';
      triggerBtn?.classList.remove('tw-hidden');
      submitBtn?.classList.add('tw-hidden');
    }
  }

  updateValues(opt) {
    this.selectWrapper = this.querySelector('.select-wrapper');
    let prefix = '';
    let spanElement = document.createElement('span');
    spanElement.setAttribute('class', 'select-option--message');
    if(opt.classList.contains('visible')) {
      spanElement.classList.add('visible')
    }

    if (opt.value != '') {
      this.selectWrapper.classList.remove('empty');
      if (this.select.getAttribute('data-prefix')) {
        prefix = this.select.getAttribute('data-prefix');
      }

      if (opt.getAttribute('data-message')) {
        spanElement.innerHTML = '(' + opt.getAttribute('data-message') + ')';
      }
    } else {
      this.selectWrapper.classList.add('empty');
    }

    this.valueText.innerHTML = prefix + ' ' + opt.innerHTML;
    this.updateMobileTrigger(opt.innerHTML);
    this.valueText.appendChild(spanElement);
    this.hiddenInput.value = opt.value;
    this.select.value = opt.value;
  }

  getSelectOptions() {
    let options = this.select.options;
    if (!options.length) return [];
    return Object.values(options);
  }

  getDefaultOption() {
    const options = this.getSelectOptions();
    const selectedOption =
      options.find((option) => option.selected && option.value !== '-' && option.value !== '') ||
      options.find((option) => option.value === '-');

    if (!selectedOption) return;

    this.updateValues(selectedOption);
    if (selectedOption.value !== '-') {
      this.updateStickyButton(selectedOption);
    }
  }

  createOptions() {
    if (!this.selectContainer) return;
    this.selectContainer.innerHTML = '';
    if (!this.select) return;
    this.getSelectOptions().forEach((option) => {
      if (option.value == '---' && this.select.nextElementSibling.nodeName == 'LABEL') {
        option.innerHTML = this.select.nextElementSibling.innerHTML;
      }

      let optionElement = document.createElement('li');

      optionElement.setAttribute('class', option.classList.contains('separator') ? 'separator' : 'select-option tw-group/option');
      if(option.classList.contains('visible')) {
        optionElement.classList.add('visible')
      }

      optionElement.setAttribute('data-value', option.value);
      /* Hide 'select opition if no value' */
      if (option.value == '-') {
        optionElement.classList.add('tw-hidden');
      }

      let spanElement = document.createElement('span');
      spanElement.setAttribute('class', 'select-option--message');
      if (option.getAttribute('data-message')) {
        spanElement.innerHTML = option.getAttribute('data-message');
      }
      if(option.classList.contains('visible')) {
        spanElement.classList.add('visible')
      }
      let valueElement = document.createElement('span');
      valueElement.setAttribute('class', 'select-option--value');
      valueElement.innerHTML = option.innerHTML;
      optionElement.appendChild(valueElement);
      optionElement.appendChild(spanElement);

      if (option.disabled) {
        optionElement.setAttribute('disabled', true);
        optionElement.classList.add('disabled');
        if(!Antonioli.isB2B){
          if(option.hasAttribute('data-button')) {
            let btnElement = document.createElement('button');
            const btnValues = option.hasAttribute('data-button-values') ? option.getAttribute('data-button-values') : false
            const btnTrigger = option.hasAttribute('data-button-sidebar') ? option.getAttribute('data-button-sidebar') : false
            btnElement.setAttribute('class', 'tw-link tw-inline-block tw-no-underline tw-text-[1.2rem] tw-pointer-events-auto');
            btnElement.setAttribute('data-product-data', btnValues);
            btnElement.setAttribute('sidebar-open', btnTrigger);
            btnElement.innerHTML = Antonioli.languages.notifyBtn;
            spanElement.appendChild(btnElement);
          }
        }
      };
      optionElement.addEventListener('click', (e) => {
        if(e.target.nodeName == 'BUTTON') {
          e.preventDefault();
          e.stopImmediatePropagation();
          this.selected(this.getSelectOptions()[0]);
          if(e.target.getAttribute('sidebar-open')) {
            publish(PUB_SUB_EVENTS.sidebarOpen, { 
              source: e.target.getAttribute('sidebar-open'), 
              value: e.target.closest('li').getAttribute('data-value'),
              sidebar: 'notifyme-popup'
            });
          }
        } else {
          this.selected(option);
          this.close();
        }
        
      });

      this.selectContainer.appendChild(optionElement);
    });
  }


  clickOutside(event) {
    if (!this.isOpen) return;
    if (this.selectListContainer?.contains(event.target)) return;
    if (!event.target.closest('custom-select') && event.target != this && !event.target.dataset.mobileDrawer && !event.target.closest('mobile-drawer')) {
      this.isOpen = false;
      this.close()
      
      // workaround, probably have to be fixed 
      this.position !== 'absolute' && this.selectListContainer.remove();
    }
  }

  updateMobileTrigger(option) {
    if(this.isMobile && this.selectTrigger) {
      const selectTriggerValue =  this.selectTrigger.querySelector('.select-value')
      selectTriggerValue.innerHTML = option;
      const triggerW = Math.ceil(this.selectTrigger.getBoundingClientRect().width);
      if(triggerW > 0)
        this.select.style.width = triggerW + 'px'
    }
  }

}

customElements.define('custom-select', CustomSelect);
